module.exports = __webpack_public_path__ + "img/右上框.24e26c4d.png";